/**
 * SPR-1206 C — GA4 host policy: www vs info are separate measurement surfaces.
 *
 * - www (LandingSite) owns acquisition stream G-ELLRDSWMY7.
 * - info / info2 must never load that www measurement ID (no shared property, no linker).
 * - A dedicated info measurement ID may be set via VITE_PUBLIC_GOOGLE_ANALYTICS_ID
 *   only after GA Admin creates a separate web stream; until then leave the env empty.
 * - GTM snippet stays out of both hosts while gtag is live (no double-fire).
 */

/** Marketing / acquisition stream for www.hatzdaka.org only. */
export const WWW_GA_MEASUREMENT_ID = 'G-ELLRDSWMY7';

export function isWwwAnalyticsHost(hostname: string): boolean {
  const host = hostname.trim().toLowerCase();
  return host === 'www.hatzdaka.org' || host === 'hatzdaka.org';
}

/** Personal-area hosts (prod + staging). */
export function isInfoAnalyticsHost(hostname: string): boolean {
  const host = hostname.trim().toLowerCase();
  return host === 'info.hatzdaka.org' || host === 'info2.hatzdaka.org';
}

/**
 * Measurement ID the personal area is allowed to initialize on this host.
 * Returns empty when: no env id, wrong host, or the env still points at the www ID.
 */
export function resolveInfoGaMeasurementId(
  envMeasurementId: string | undefined | null,
  hostname: string,
): string {
  const id = (envMeasurementId ?? '').trim();
  if (!id) return '';
  if (!isInfoAnalyticsHost(hostname)) return '';
  // Hard guard: never send the www acquisition stream from info/info2.
  if (id === WWW_GA_MEASUREMENT_ID) return '';
  return id;
}
